// app/javascript/controllers/guests_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactSelect"]

  updateContacts(event) {
    const customerId = event.target.value

    this.contactSelectTarget.innerHTML = ""

    if (!customerId) return

    fetch(`/customers/${customerId}/contacts_for_select`, {
      headers: { Accept: "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        const contacts = data.contacts || []

        this.contactSelectTarget.innerHTML = ""

        contacts.forEach(contact => {
          const option = document.createElement("option")
          option.value = contact.id
          option.textContent = contact.name
          this.contactSelectTarget.appendChild(option)
        })
      })
  }
}